import { Switch } from "@mantine/core";
import { useLocalStorage } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

import { SettingRow } from "@/components/elements/Settings/SettingRow";
import { useUpdateUserSettings } from "@/services/profile/update-user-settings";

export const NumberFormatter = () => {
  const { t } = useTranslation();

  const [compact, setCompact] = useLocalStorage<boolean>({
    key: "number-formatting",
    defaultValue: false,
  });
  const updateSettings = useUpdateUserSettings();

  return (
    <SettingRow
      label={t("components.header.number_format.title")}
      leftSection={t("components.header.number_format.full")}
      rightSection={t("components.header.number_format.rounded")}
    >
      <Switch
        checked={compact}
        onChange={(event) => {
          const isCompact = event.currentTarget.checked;
          setCompact(isCompact);
          updateSettings.mutate({ roundedValue: isCompact ? "compact" : "full" });
        }}
      />
    </SettingRow>
  );
};
